import events from "../events/EventsObservable";
import ButtonSounds from "./ButtonSounds";
import {ACTION_EVENTS} from "./UserAction";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";

@injectable()
export default class AudioController {
    buttonSounds: ButtonSounds
    constructor(
        @inject(SERVICE_IDENTIFIER.ButtonSounds) buttonSounds: ButtonSounds
    ) {
        this.buttonSounds = buttonSounds

        this.subscribe()
    }

    subscribe(): void {
        events.subscribe([
            ACTION_EVENTS.ACTION_SPIN,
            ACTION_EVENTS.ACTION_SKIP,
            ACTION_EVENTS.ACTION_AUTOSTART_STOP,
            ACTION_EVENTS.ACTION_FORCESTOP,
            ACTION_EVENTS.ACTION_AUTOSTART_OPEN,
            ACTION_EVENTS.ACTION_AUTOSTART_CLOSE,
            ACTION_EVENTS.ACTION_BETMENU_OPEN,
            ACTION_EVENTS.ACTION_BETMENU_CLOSE,
            ACTION_EVENTS.ACTION_BURGER_OPEN,
            ACTION_EVENTS.ACTION_BURGER_CLOSE,
            ACTION_EVENTS.ACTION_INFO_ARROW,
            ACTION_EVENTS.ACTION_INFO_TOGGLE,
            ACTION_EVENTS.ACTION_HOME_BUTTON,
            ACTION_EVENTS.ACTION_SOUND_TOGGLE,
            ACTION_EVENTS.ACTION_PARAGRAPH_OPEN,
            ACTION_EVENTS.ACTION_PARAGRAPH_CLOSE,
            ACTION_EVENTS.ACTION_HISTORY_OPEN,
            ACTION_EVENTS.ACTION_HISTORY_CLOSE,
            ACTION_EVENTS.ACTION_MAXBET,
            ACTION_EVENTS.ACTION_AUTOSTART_CHOOSE,
            ACTION_EVENTS.ACTION_FULLSCREEN_REQUEST,
            ACTION_EVENTS.ACTION_FULLSCREEN_EXIT_REQUEST,
            ACTION_EVENTS.ACTION_BET_DEC,
            ACTION_EVENTS.ACTION_BET_INC,
            ACTION_EVENTS.ACTION_COIN_DEC,
            ACTION_EVENTS.ACTION_COIN_INC,
            ACTION_EVENTS.ACTION_LINES_DEC,
            ACTION_EVENTS.ACTION_LINES_INC,
            ACTION_EVENTS.ACTION_HANDEDNESS_TOGGLE,
            ACTION_EVENTS.ACTION_SLIDER_SLIDE
        ], () => this.buttonSounds.click())
    }
}